import { type OpenApiSchemaProductVariantListItem } from '#shared/api/schema';
import { createPaginateDataGridProvider, type GridRow } from '#shared/components/grid';
import { api, variantGridTagInvalidator } from '../api/api';

export type ProductVariantGridRow = GridRow<OpenApiSchemaProductVariantListItem>;

export const useProductVariantsDataGridProvider = createPaginateDataGridProvider({
    getPageNumber: (params) => params.payload.page ?? 0,
    getPerPage: (params) => params.payload.per_page ?? 25,
    getTotal: (result) => result.total_count,
    getRows: (result) =>
        result.items.map((item) => {
            return {
                id: item.id + '_' + item.product_id,
                attributes: item,
            };
        }),
    getItemFromRow: (row) => row.attributes,
    getSelectableId: (_, rows) => rows.map(({ id }) => id),
    endpoint: api.endpoints.getVariantsForGrid,
    invalidateTagHelper: variantGridTagInvalidator,
});
